module.exports = __webpack_public_path__ + "static/media/Lattice_and_agents.983962e3.png";